import './SessionConfirm.scss';
import {
  postSessionParticipation,
  selectHasErrorPostSessionParticipation,
  selectIsPostingSessionParticipation
} from '../../ducks/entities';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Loader from '../../components/Loader/Loader';
import messages from './messages';
import { selectLocalSettings } from '../../ducks/settings';
import { setTitle } from '../../utils/generic';
import siteMessages from '../root/siteMessages';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

const SessionConfirm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const intl = useIntl();
  const navigate = useNavigate();
  const lang = useSelector(selectLocalSettings);
  const hasErrorPostSessionParticipation = useSelector(
    selectHasErrorPostSessionParticipation
  );
  const isPostingSessionParticipation = useSelector(
    selectIsPostingSessionParticipation
  );

  useEffect(() => {
    setTitle(intl.formatMessage({ ...messages.pageTitle }));
    dispatch(postSessionParticipation(id!));
  }, []);

  const ErrorParticipation = () => (
    <>
      <h3>{intl.formatMessage({ ...messages.oops })} ✋</h3>
      <p>{intl.formatMessage({ ...messages.invalidParticipation })}</p>
      <div className="grid">
        <Button className="mt-2" onClick={() => navigate(`/${lang}/`)}>
          {intl.formatMessage({ ...siteMessages.ERROR_HOME })}
        </Button>
        <Button
          className="mt-2"
          variant="secondary"
          onClick={() => navigate(`/${lang}/contactus`)}
        >
          {intl.formatMessage({ ...messages.contactUs })}
        </Button>
      </div>
    </>
  );

  const SuccessParticipation = () => (
    <>
      <h3>{intl.formatMessage({ ...messages.confirmHeader })} ✔️</h3>
      <p>{intl.formatMessage({ ...messages.confirmText })}</p>
      <Button className="mt-3" onClick={() => navigate(`/${lang}/`)}>
        {intl.formatMessage({ ...siteMessages.ERROR_HOME })}
      </Button>
    </>
  );

  return (
    <div className="fixFooter">
      {isPostingSessionParticipation ? (
        <Loader className="lds-black lds-large" />
      ) : (
        <div className="d-flex flex-column align-items-center">
          {hasErrorPostSessionParticipation ? (
            <ErrorParticipation />
          ) : (
            <SuccessParticipation />
          )}
        </div>
      )}
    </div>
  );
};

export default SessionConfirm;
